import * as yup from 'yup'

import { getMessage } from '../../util/IntlMessages'

export const MATERIAL_VALIDATION_SCHEMA = yup.object().shape({
  active: yup
    .boolean()
    .typeError('must be boolean')
    .required(getMessage('isRequired', getMessage('active'))),

  name: yup.string().typeError('Preencha um nome válido').nullable().required(getMessage('typeMaterialName')),

  brandId: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('selectABrand')),

  tecnologiaId: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('selectATechnology')),

  breederId: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('selectABreeder'))
})
